import { DEVICE_UUID } from 'configs/constant'
import { useEffect, useRef } from 'react'
import { isMobile } from 'react-device-detect'
import { useParams } from 'react-router-dom'
import { apiExpandToken } from 'services/authService'

const useExpandExpiredToken = () => {
  const isDoing = useRef<any>(false)
  const { app } = useParams()

  const handleMouseMove = () => {
    if (!isDoing.current) {
      isDoing.current = true
    }
  }
  useEffect(() => {
    const bodyElement = document.querySelector('body')
    if (bodyElement) {
      if (isMobile) {
        bodyElement.addEventListener('touchstart', handleMouseMove)
      } else {
        bodyElement.addEventListener('mousemove', handleMouseMove)
      }
    }
    return () => {
      if (bodyElement) {
        if (isMobile) {
          bodyElement.removeEventListener('touchmove', handleMouseMove)
        } else {
          bodyElement.removeEventListener('mousemove', handleMouseMove)
        }
      }
    }
  }, [isMobile])

  useEffect(() => {
    const timeInterval = setInterval(async () => {
      if (isDoing.current) {
        await apiExpandToken({
          app_id: app || '',
          device_token: localStorage.getItem(DEVICE_UUID) || ''
        })
        isDoing.current = false
      }
    }, 5 * 60 * 1000)

    return () => {
      clearInterval(timeInterval)
    }
  }, [])
}

export default useExpandExpiredToken